var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_10098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 0.785767H3.92801C3.51124 0.785767 3.11155 0.951328 2.81684 1.24603C2.52215 1.54073 2.35658 1.94042 2.35658 2.3572V16.5001L0.785156 21.2143L7.07087 19.6429H19.6423C20.059 19.6429 20.4588 19.4773 20.7535 19.1826C21.0481 18.888 21.2137 18.4882 21.2137 18.0715V10.2143",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.142 12.7865L8.42773 13.6351L9.21345 8.85795L16.6464 1.45652C16.7924 1.30924 16.9662 1.19233 17.1577 1.11255C17.3491 1.03277 17.5545 0.991699 17.7621 0.991699C17.9695 0.991699 18.1749 1.03277 18.3663 1.11255C18.5579 1.19233 18.7317 1.30924 18.8778 1.45652L20.5435 3.12224C20.6908 3.26832 20.8077 3.44212 20.8875 3.63361C20.9672 3.82511 21.0083 4.03051 21.0083 4.23795C21.0083 4.4454 20.9672 4.6508 20.8875 4.84229C20.8077 5.03379 20.6908 5.20759 20.5435 5.35367L13.142 12.7865Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_10098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsIcon);
export default __webpack_public_path__ + "static/media/testimonialsIcon.5a2f1ba480bc1827ea4e943199154d3b.svg";
export { ForwardRef as ReactComponent };